import {Injectable} from '@angular/core';
import {ErrorService} from './error.service';
import {HttpHeaders, HttpClient} from '@angular/common/http';
import {ConfigurationService} from './configuration.service';
import {Hierarchy} from '@model/Hierarchy';
import {OIExpInvCurrent} from '@model/OIExpInvCurrent';
import {InvoiceException} from '@model/InvoiceException';
import {InvoiceExport} from '@model/InvoiceExport';
import {Observable,lastValueFrom} from 'rxjs';
import {HomeOffice} from '@model/HomeOffice';
import {GLCodeInvProcessing} from '@model/GLCodeInvProcessing';
import {GLUpdate} from '@model/GLUpdate';
import {catchError, tap} from 'rxjs/operators';
import {ExportDate} from '@model/ExportDate';
import {ChainInvoice} from '@model/ChainInvoice';
import {Excheck} from '@model/Excheck';
import {Download} from '@model/Download'
import {DialogType, FSInvoiceDialogService} from "~/app/core/services/fsinvoice.dialog.service";
import {BaseService} from "~/app/core/services/base.service";

@Injectable({
  providedIn: 'root'
})
export class InvoiceProcessingService {
  readonly GETAPCLISTURL = '/invprocess/aplist/';
  readonly HIERLIST = '/invprocess/hierlist/';

  readonly INVOICE_EXPORT = '/invprocess/export/'; // {hoId}/{invoiceList}/{qb}/{es}
  readonly INVOICE_DOWNLOAD = '/invprocess/download/'; // {hoId}/{invoiceList}/{qb}/{es}
  readonly INVPROCESS_EXPORT_APPKG = '/invprocess/export/appkg/'; // {hoid}
  readonly INVPROCESS_EXPORT_APSUM = '/invprocess/export/apsum/'; // {hoId}/{invoiceList}
  readonly INVPROCESS_EXPORT_NSINV = '/invprocess/export/nsinv/'; // {hoId}/{invoiceList}
  readonly INVPROCESS_EXPORT_APHD = '/invprocess/export/aphd/'; // {hoId}/{invoiceList}
  readonly INVPROCESS_EXPORT_VOUCHER = '/invprocess/export/voucher/'; // {hoId}/{invoiceList}
  readonly INVPROCESS_EXPORT_MSISETUP = '/invprocess/export/msisetup/'; // {hoId}/{invoiceList}
  readonly INVPROCESS_EXPORT_MASXPORT = '/invprocess/export/masxport/'; // {hoId}/{invoiceList}
  readonly INVPROCESS_EXPORT_APHDR4 = '/invprocess/export/aphdr4/'; // {hoId}/{invoiceList}
  readonly INVPROCESS_EXPORT_APCLARUS = '/invprocess/export/apclarus/'; // {hoId}/{invoiceList}
  readonly INVPROCESS_EXPORT_QBK = '/invprocess/export/qbk/'; // {hoId}/{invoiceList}
  readonly INVPROCESS_EXPORT_ACCPAC = '/invprocess/export/accp/'; // {hoId}/{invoiceList}
  readonly INVPROCESS_EXPORT_ACUITY = '/invprocess/export/acuity/';
  readonly INVPROCESS_EXPORT_AMERINVC = '/invprocess/export/amer/'; // {hoId}/{invoiceList}
  readonly SEGMENTSEP = '/invprocess/segsub/'; // {hoId}/{username}
  readonly LISTEXCEPTIONS = '/exceptions/listexceptions/'; // {hoId}/{invoiceList}
  readonly EXCEPTIONSCOUNT = '/exceptions/excheck/'; // {hoId}/{invoiceList}

  readonly INVPROCESS_EXPORT_DATE = '/invprocess/export/date'; // HTTP:PUT add body JSON with hoid, {chanInvList, chain - invdate - invnum }
  readonly HOLIST = '/invprocess/holist/'; // {hoid}
  readonly LISTCODES = '/exceptions/listcodes/'; // {hoId}/
  readonly EXCEPTIONS_UPDATE_GL = '/exceptions/updategl'; // HTTP:PUT add BODY with hoid,chn,div,itemnum,glcode

  public selectedInvoices: string = '';
  public downloadType: string = '';
  public downloadTypes = [];
  public isSegSep: any;

  public excheck: Excheck = new Excheck();
  public download: Download = new Download();

  httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  };
  public selectedHomeOffice: HomeOffice;
  chnInvList: ChainInvoice[];

  constructor(private baseService: BaseService,
              private configuration: ConfigurationService,
              private errorService: ErrorService,
              private dialogService: FSInvoiceDialogService) {
  }

  async getInvoices(type: string) {
    if (type == 'Current') {
      type = 'C';
    } else {
      type = 'A';
    }
    console.warn('getInvoices: ' + this.configuration.RESTURL + this.GETAPCLISTURL + this.selectedHomeOffice.hoId + '/' + type);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getInvoices',
      'invoice-processing',
      this.configuration.RESTURL + this.GETAPCLISTURL + this.selectedHomeOffice.hoId + '/' + type))
      .catch(this.errorService.handleError('InvoiceProcessingService getInvoices', []));
    return results as OIExpInvCurrent[];
  }

  async getHierarchyList() {
    console.warn('getHierarchyList: ' + this.configuration.RESTURL + this.HIERLIST + this.selectedHomeOffice.hoId);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getHierarchyList',
      'invoice-processing',
      this.configuration.RESTURL + this.HIERLIST + this.selectedHomeOffice.hoId))
      .catch(this.errorService.handleError('InvoiceProcessingService getHierarchyList', []));
    return results as Hierarchy[];
  }

  public getExCheck() {
    this.excheck.hoId = this.selectedHomeOffice.hoId;
    var array = [];
    array.push(this.selectedInvoices);
    this.excheck.invoices = array;
    return this.excheck;
  }

  public getDownload() {
    this.download.hoId = this.selectedHomeOffice.hoId;
    this.download.es = this.isSegSep;
    var array = [];
    array.push(this.selectedInvoices);
    this.download.invoices = array;
    return this.download;
  }

  async isSegSepEnabled(userId: string) {
    const results = await lastValueFrom(this.baseService.getHttp(
      'isSegSepEnabled',
      'invoice-processing',
      this.configuration.RESTURL + this.SEGMENTSEP + this.selectedHomeOffice.hoId + '/' + userId))
      .catch(this.errorService.handleError('InvoiceProcessingService isSegSepEnabled', []));
    return results;
  }

  // async getExceptionsCount() {
  //   console.warn('getExceptionsCount: ' + this.configuration.RESTURL + this.EXCEPTIONSCOUNT + ' -BODY: ' + JSON.stringify(this.getExCheck()));
  //   const results = await this.http.post(
  //     this.configuration.RESTURL + this.EXCEPTIONSCOUNT, JSON.stringify(this.getExCheck()))
  //     .toPromise()
  //     .catch(this.errorService.handleError('InvoiceProcessingService getExceptionsCount', []));
  //   console.log(results);
  //   return results;
  // }

  async getExceptionsCount() {
    console.warn('getExceptionsCount: ' + this.configuration.RESTURL + this.EXCEPTIONSCOUNT + ' -BODY: ' + JSON.stringify(this.getExCheck()));
    const results = await lastValueFrom(this.baseService.postHttpJson(
      'getExceptionsCount',
      'invoice-processing',
      this.configuration.RESTURL + this.EXCEPTIONSCOUNT,
      JSON.stringify(this.getExCheck())))
      .catch(this.errorService.handleError('InvoiceProcessingService getExceptionsCount', []));
    console.log(results);
    return results;
  }


  async getExcpetions(invoiceList: string) {
    console.warn('getExcpetions: ' + this.configuration.RESTURL + this.LISTEXCEPTIONS + ' -BODY: ' + JSON.stringify(this.getExCheck()));
    const results = await lastValueFrom(this.baseService.postHttpResponsePlain(
      'getExceptions',
      'invoice-processing',
      this.configuration.RESTURL + this.LISTEXCEPTIONS, JSON.stringify(this.getExCheck())))
      .catch(this.errorService.handleError('InvoiceProcessingService getExceptions', []));
    return results as InvoiceException[];
  }

  async getGLCodes() {
    console.warn('getGLCodes: ' + this.configuration.RESTURL + this.LISTCODES + this.selectedHomeOffice.hoId);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getGLCodes',
      'invoice-processing',
      this.configuration.RESTURL + this.LISTCODES + this.selectedHomeOffice.hoId))
      .catch(this.errorService.handleError('InvoiceProcessingService getGLCodes', []));
    return results as GLCodeInvProcessing[];
  }

  async exportInvoices(invoiceList: string, quickbooks: string, exportSeg: string,) {
    console.warn('exportInvoices: ' + this.configuration.RESTURL + this.INVOICE_EXPORT + this.selectedHomeOffice.hoId + '/' + invoiceList + '/' + quickbooks + '/' + exportSeg);
    const results = await lastValueFrom(this.baseService.getHttp(
      'exportInvoices',
      'invoice-processing',
      this.configuration.RESTURL + this.INVOICE_EXPORT + this.selectedHomeOffice.hoId + '/' + invoiceList + '/' + quickbooks + '/' + exportSeg))
      .catch(this.errorService.handleError('InvoiceProcessingService exportInvoices', []));
    return results as InvoiceExport[];
  }

  downloadInvoices(invoiceList: string, quickbooks: string, exportSeg: string): Observable<Blob> {
    console.warn('downloadInvoices: ' + this.configuration.RESTURL + this.INVOICE_DOWNLOAD + this.selectedHomeOffice.hoId + '/' + invoiceList + '/' + quickbooks + '/' + exportSeg, {responseType: 'blob'});
    return this.baseService.getHttpBlob(
      'downloadInvoices',
      'invoice-processing',
      this.configuration.RESTURL + this.INVOICE_DOWNLOAD + this.selectedHomeOffice.hoId + '/' + invoiceList + '/' + quickbooks + '/' + exportSeg);
  }

  async getHoList(userId: string) {
    console.warn('getHoList: ' + this.configuration.RESTURL + this.HOLIST + userId);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getHoList',
      'invoice-processing',
      this.configuration.RESTURL + this.HOLIST + userId))
      .catch(this.errorService.handleError('InvoiceProcessingService getHoList', []));
    return results as HomeOffice[];
  }

  async getDownloadType() {
    this.downloadTypes = [];
    console.warn('downloadType: ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_APPKG + this.selectedHomeOffice.hoId);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getDownloadType',
      'invoice-processing',
      this.configuration.RESTURL + this.INVPROCESS_EXPORT_APPKG + this.selectedHomeOffice.hoId))
      .catch(this.errorService.handleError('InvoiceProcessingService getDownloadType', []));
    return results as string;
  }

  downloadFile(fileName: string): Observable<Blob> {
    if (fileName === ExportType.ACCPAC) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_ACCPAC + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.ACCPAC,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_ACCPAC, JSON.stringify(this.getDownload()));
    }
    if (fileName === ExportType.ACUITY) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_ACUITY + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.ACUITY,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_ACUITY, JSON.stringify(this.getDownload()));
    }
    if (fileName === ExportType.AMERINVC) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_AMERINVC + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.AMERINVC,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_AMERINVC, JSON.stringify(this.getDownload()));
    }
    if (fileName === ExportType.APCLARUS) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_APCLARUS + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.APCLARUS,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_APCLARUS, JSON.stringify(this.getDownload()));
    }
    if (fileName === ExportType.APHDR4) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_APHDR4 + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.APHDR4,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_APHDR4, JSON.stringify(this.getDownload()));
    }
    if (fileName === ExportType.APHDRDYN) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_APHD + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.APHDRDYN,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_APHD, JSON.stringify(this.getDownload()));
    }
    if (fileName === ExportType.APSUMM4) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_APSUM + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.APSUMM4,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_APSUM, JSON.stringify(this.getDownload()));
    }
    if (fileName === ExportType.MASXPORT) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_MASXPORT + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.MASXPORT,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_MASXPORT, JSON.stringify(this.getDownload()));
    }
    if (fileName === ExportType.MSISETUP) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_MSISETUP + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.MSISETUP,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_MSISETUP, JSON.stringify(this.getDownload()));
    }
    if (fileName === ExportType.NSINV) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_NSINV + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.NSINV,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_NSINV, JSON.stringify(this.getDownload()));
    }
    if (fileName === ExportType.QBOOKSINVC) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_QBK + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.QBOOKSINVC,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_QBK, JSON.stringify(this.getDownload()));
    }
    if (fileName === ExportType.VOUCHER) {
      console.warn('Download file - ' + fileName + ': ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_VOUCHER + 'BODY- ' + JSON.stringify(this.getDownload()));
      return this.baseService.postHttpJsonBlob(
        'export: ' + ExportType.VOUCHER,
        'invoice-processing',
        this.configuration.RESTURL + this.INVPROCESS_EXPORT_VOUCHER,
        JSON.stringify(this.getDownload()));
    }
  }


  updateGL(glUpdate: GLUpdate[]): Observable<any> {
    console.warn('updateGL: ' + this.configuration.RESTURL + this.EXCEPTIONS_UPDATE_GL + '    -iBODY: ' + JSON.stringify(glUpdate) + ' this.httpOptions: ' + this.httpOptions);
    return this.baseService.putHttpObject<any>(
      'updateGL',
      'invoice-processing',
      this.configuration.RESTURL + this.EXCEPTIONS_UPDATE_GL, JSON.stringify(glUpdate), this.httpOptions)
      .pipe(
        tap(_ => console.log('updating...: ' + glUpdate)),
        catchError(this.errorService.handleError('updateGL', glUpdate))
      );
  }

  exportDate(exportDate: ExportDate): Observable<any> {
    console.log('exportDate');
    console.log(exportDate);
    console.log(JSON.stringify(exportDate));
    console.warn('exportDate: ' + this.configuration.RESTURL + this.INVPROCESS_EXPORT_DATE + '    -BODY: ' + JSON.stringify(exportDate) + ' this.httpOptions: ' + this.httpOptions);
    return this.baseService.putHttpObject<any>(
      'exportDate',
      'invoice-processing',
      this.configuration.RESTURL + this.INVPROCESS_EXPORT_DATE, JSON.stringify(exportDate), this.httpOptions)
      .pipe(
        tap(_ => console.log('updating...: ' + exportDate)),
        catchError(this.errorService.handleError('exportDate', exportDate))
      );
  }

  public showExportDownload(fileName: string): void {
    this.downloadFile(fileName)
      .subscribe({ next: (x) => {
          const newBlob = new Blob([x], {type: 'application/json'});
          const downloadURL = window.URL.createObjectURL(newBlob);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = fileName;
          link.click();
        },
        error:(err) => {
          console.error(err);
          if (err.status === 406) {
            this.dialogService.openDialog({
              type: DialogType.ERROR,
              title: 'Export',
              content: 'No data retrieved for export.',
              actions: [
                {text: 'Ok', primary: true},
              ],
              width: 400
            }).then(r => r);
          }
        }});
  }
}


export enum ExportType {
  APCLARUS = 'APCLARUS.TXT',
  APHDR4 = 'APHDR4.TXT',
  APHDRDYN = 'APHDRDYN.TXT',
  APSUMM4 = 'APSUMM4.TXT',
  MASXPORT = 'MASXPORT.TXT',
  MSISETUP = 'MSISETUP.TXT',
  NSINV = 'NSINV.CSV',
  QBOOKSINVC = 'QBOOKSINVC.CSV',
  VOUCHER = 'VOUCHER.DTA',
  ACCPAC = 'ACCPAC.CSV',
  ACUITY = 'ACUITY4.DEL',
  AMERINVC = 'AMERINVC.CSV'
}
